(function () {
  const bar = document.getElementById('sticky-cart-bar');
  if (!bar) return;

  // メインのATCボタンを取得
  const mainForm = document.querySelector('form[action="/cart/add"]');
  const mainBtn = mainForm ? mainForm.querySelector('[name="add"]') : null;
  const stickyBtn = document.getElementById('sticky-atc-btn');
  const stickyVariantLabel = document.getElementById('sticky-variant-label');
  const stickyPrice = document.getElementById('sticky-price');

  if (!mainBtn) return;

  // 価格フォーマット
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('ja-JP', {
      style: 'currency', currency: window.Shopify?.currency?.active || 'JPY'
    });
  }

  // バリアント情報を更新
  function updateStickyInfo() {
    const variantSelect = mainForm.querySelector('[name="id"]');
    if (!variantSelect) return;

    const variantId = variantSelect.value;
    const variantData = window.__stickyCartVariants?.[variantId];
    if (variantData) {
      stickyVariantLabel.textContent = variantData.title !== 'Default Title' ? variantData.title : '';
      stickyPrice.textContent = formatMoney(variantData.price);
    }
  }

  // スクロール監視
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      } else {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
        updateStickyInfo();
      }
    },
    { threshold: 0.2 }
  );
  observer.observe(mainBtn);

  // スティッキーボタンクリック → メインフォームをsubmit
  stickyBtn.addEventListener('click', () => {
    mainBtn.click();
  });

  // バリアント変更を監視
  mainForm.addEventListener('change', updateStickyInfo);
})();
